module.exports = __webpack_public_path__ + "static/media/6 1 Ordforstaelse Intro.df6e438c.mp3";